import React from "react";
import { GetCorServicei } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
export default class PopUpCsConfirm extends React.Component {
    state = {
        col: [],
        rows: [],
        Htext: "",
        casschkbox: "far fa-square",
        casschkboxs: false,
        docno: ""
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        var dataArray = [];
        console.log(this.props.table);
            var Url = "CC_SaleOrder/Confirm?All";
        setTimeout(() => {
            GetCorServicei(Url).then(res => {
                var j = 0;
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        dataArray[j] = {
                            number: i + 1,
                            ArCode: res.data[i].CODE,
                            Description: res.data[i].MYNAMETH,
                            SB: "0",
                        }
                        j++;
                    }
                    this.setState({ products: dataArray });
                    this.GetSearchTimeout();
                } else {
                    dataArray = [];
                    this.setState({ products: dataArray });
                    this.GetSearchTimeout();
                }
            });
            this.setState({ products: dataArray, Htext: "เลือกรายการย่อย" });
        }, 200);
    }
    onSelectRow = (data, col, id, row) => {
        if (col > 0 && data.ArCode !== undefined) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.products;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            //------------------------
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.products.length; i++) {
                if (this.state.products[i].SB === "1") {
                    reData[j] = {
                        ArCode: this.state.products[i].ArCode,
                        Description: this.state.products[i].Description,
                    }
                    j++
                }
            }
            if (reData.length !== 0) {
                this.props.Get_PopUpConfirm(reData);
            }
        }
    }
    render() {
        return (

            <div className='popup' style={{ 'z-index': '100' }} >
                <div className='popup_inner'>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1">
                            <i class="fas fa-search">{this.state.Htext} </i>
                        </div>
                        <div class="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i class="fas fa-times"></i>
                        </div>
                    </div>
                    <div class="panel-body divTable" align="right">
                        <div style={{ marginTop: "10px" }}>
                            <BootstrapTable
                                data={this.state.products}
                                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา", }}
                                height="550"
                                hover condensed search>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="10" dataField='number' isKey ><div onClick={this.props.closePopup}><i class="fas fa-reply-all" ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="70" dataField='ArCode' > รหัส </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='Description' > ชื่อ/คำอธิบาย </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        {this.state.TableHidden ? ("") : (
                            <button class="PUSDbtn" onClick={this.props.closePopup} >
                                <i class="fas fa-reply-all"> กลับ </i>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}